import { GzNodeDirectorWebComponent } from './component/GzNodeDirectorWebComponent';
import { WEB_COMPONENT_GZ_NODE_DIRECTOR } from '../../../../webcomponents.constants';

export { GzNodeDirectorWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_NODE_DIRECTOR, GzNodeDirectorWebComponent);
